module.exports = __webpack_public_path__ + "static/media/pic-history5.1bcb104f.webp";